import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Grid from '@mui/material/Grid';
import _ from 'lodash';
import {DepartmentType} from '../../../../controls/agyle/dictionaries';
import {useStylesECDS} from './ecdsStyle';
import {useSelector} from 'react-redux';
import {departmentType} from '../../../../store/reducers/dicts';
import config from '../../../../app/config';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import {currentMap} from '../../../../store/reducers/ward';
import {cleanObject} from '../../../../util/patientContextUtil';

const AttendanceLocation = (props) => {
    const {t} = useTranslation();
    const classes = useStylesECDS();
    const newCurrentMap = useSelector(currentMap);

    const {isSmall} = props;

    // Attendance Location Dataset
    const [attendanceLocation, setAttendanceLocation] = useState({
        OrganisationSiteIdentifier_OfTreatment: '',
        EmergencyCareDepartmentType: null,
    });

    // Dictionaries
    const departmentTypeDict = useSelector(departmentType);

    // For ReadOnly Data
    const disableData = useRef({});

    // Validation
    const validationEnabled = config?.modules?.forms?.ecds?.validation || false;
    const [error, setError] = useState({
        org: validationEnabled,
        department: validationEnabled,
    });

    // Initial Data
    useEffect(() => {
        let data = {};
        let dataToBlock = {};

        if (props.patient?.studies?.EmergencyCare?.EmergencyCareAttendanceLocation) {
            data = {...props.patient?.studies?.EmergencyCare?.EmergencyCareAttendanceLocation};
            data = {
                ...data,
                EmergencyCareDepartmentType: data.EmergencyCareDepartmentType
                    ? _.find(departmentTypeDict, {__code: data.EmergencyCareDepartmentType}) : null,
            };
        }

        if (newCurrentMap?.hospitalId) {
            data = {
                ...data,
                OrganisationSiteIdentifier_OfTreatment: newCurrentMap?.hospitalId || '',
            };
        }

        data = {
            ...data,
            EmergencyCareDepartmentType: data.EmergencyCareDepartmentType
                ? data.EmergencyCareDepartmentType : _.find(departmentTypeDict, {__code: '01'}),
        };

        setAttendanceLocation(prevState => ({...prevState, ...data}));
        disableData.current = {...cleanObject(dataToBlock)};
    }, []);

    const updateData = () => {
        const data = {
            OrganisationSiteIdentifier_OfTreatment: attendanceLocation.OrganisationSiteIdentifier_OfTreatment,
            EmergencyCareDepartmentType: attendanceLocation.EmergencyCareDepartmentType?.__code || '',
        };
        props.setData(data);
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (validate()) {
                updateData();
            }
        }, 400);

        return () => clearTimeout(timeoutId);
    }, [attendanceLocation]);

    const changeHandler = (event) => {
        setAttendanceLocation((prevState) => ({...prevState, [event.target.name]: event.target.value}));
    };

    const setDataDictionary = (data) => {
        changeHandler({
            target: {
                name: data[0],
                value: data?.[1] || null,
            },
        });
    };

    const validate = () => {
        let check = true;

        if (validationEnabled) {
            const errorData = {
                org: !props.checkLenght(5, 9, attendanceLocation.OrganisationSiteIdentifier_OfTreatment),
                department: !props.checkLenght(2, 2, attendanceLocation.EmergencyCareDepartmentType),
            };

            setError(prevState => ({...prevState, ...errorData}));

            for (let prop in errorData) {
                if (errorData[prop]) {
                    check = false;
                    break;
                }
            }

            if (props.valid) {
                const validObj = {
                    name: 'Emergency Care Attendance Location',
                    groupStatus: 'M',
                    mandatory: !attendanceLocation.OrganisationSiteIdentifier_OfTreatment || !attendanceLocation.EmergencyCareDepartmentType,
                    errors: !check,
                    pickers: false,
                };
                props.valid(prevState => ({...prevState, 'attendanceLoc': validObj}));
            }
        }
        return check;
    };

    if (props.accordion !== 'Emergency Care Attendance Location' && props.accordion !== 'Urgent And Emergency Care Attendance Location') return null;

    return (
        <div className={classes.root}>
            <Grid container spacing={2} style={{marginTop: 1}}>
                <Grid item xs={isSmall ? 12 : 6}>
                    <AgyleTextField
                        name="OrganisationSiteIdentifier_OfTreatment"
                        label={t('Org. Site Id of Treatment')}
                        onChange={changeHandler}
                        value={attendanceLocation.OrganisationSiteIdentifier_OfTreatment || ''}
                        error={error.org}
                        helperText={error.org ? 'Input must be between 5 and 9 characters long.' : ''}
                        maxLength={9}
                        minLength={5}
                        readOnly={!!disableData?.current.OrganisationSiteIdentifier_OfTreatment}
                        fullWidth
                        debounce
                        noBorder={false}
                        withNewBackground
                        size="large"
                    />
                </Grid>

                <Grid item xs={isSmall ? 12 : 6}>
                    <DepartmentType
                        name="EmergencyCareDepartmentType"
                        label={t('Department Type')}
                        value={attendanceLocation.EmergencyCareDepartmentType}
                        onChange={(_e, val) => setDataDictionary(['EmergencyCareDepartmentType', val])}
                        error={error.department}
                        noBorder={false}
                        withNewBackground
                        size="large"
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default AttendanceLocation;
